const initial_filter = {
  page: 1,
  limit: 15,
  order: "DESC",
  order_by: "createdAt",
  keyword: null,
};
export default initial_filter;
